
  import { defineComponent } from 'vue';
  import { Button } from '@/ui/components/Button';

  export default defineComponent({
    name: 'ScheduleCreateButton',
    components: { Button },
  });
